<template>
  <div
    id="info-wrapper"
    class="info-setting d-flex align-items-center justify-content-center"
    @click.self="isShow(false)"
  >
    <div class="info-box d-flex flex-column">
      <div class="info-head">
        <div class="media align-items-center">
          <div class="media-body">
            <div class="h2">
              {{ $t("feature.homecare.fix_history") }}
            </div>
          </div>
          <div class="ml-3">
            <a
              href="javascript:void(0)"
              class="close-btn"
              @click="isShow(false)"
              title="Close"
            >
              <img src="/static/icons/close-thin.svg" />
            </a>
          </div>
        </div>
      </div>
      <div class="info-body">
        <job-history-item
          v-for="(history, index) in histories"
          :key="index"
          :history="history"
          @go="goToJob"
        />
        <div class="center p-5" v-if="histories.length < 1">
          <p>{{ $t("feature.homecare.no_history") }}</p>
        </div>
      </div>
      <div class="info-footer"></div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import JobHistoryItem from "./JobHistoryItem";

export default {
  props: {
    jobId: {
      required: true
    },
    projectId: {
      required: true
    }
  },
  components: {
    JobHistoryItem
  },
  data() {
    return {
      histories: []
    };
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    isShow(flag) {
      this.$emit("isShow", flag);
    },
    loadHistory() {
      return axios
        .get(`${process.env.HOST}/admin/homecares/${this.jobId}/histories`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          },
          params: {
            project_id: this.projectId
          }
        })
        .then(result => {
          this.histories = result.data;
          return result.data;
        })
        .catch(() => {
          this.histories = [];
        });
    },
    goToJob(history) {
      const projectId = this.$route.params.projectId;
      const jobId = history.job_order_id;
      const homeId = history.home_id;
      this.$router.push({
        name: "Homecare",
        params: { projectId, jobId },
        query: { home_id: homeId }
      });
      this.$emit("isShow", false);
    }
  }
};
</script>

<style lang="scss" scoped>
#info-wrapper {
  background-color: rgba(74, 74, 74, 0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 10;
  top: 0;
  left: 0;
}
.info-box {
  position: absolute;
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
  width: auto;
  height: auto;
  max-width: 640px;
  max-height: 480px;
}
.info-head {
  padding-top: 20px;
  padding-left: 25px;
  padding-right: 25px;
}
.info-body {
  padding: 10px 20px 0 10px;
  overflow: auto;
}
.info-footer {
  height: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  overflow: auto;
}
.h2 {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.7;
  letter-spacing: -0.1px;
  margin-top: 0;
  color: $black;
}
.sub-title {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/homecare/JobHistoryModal.vue